// extracted by mini-css-extract-plugin
export default {"title":"Title_title__zAwxm","left":"Title_left__i4gF7","center":"Title_center__tq2OV"};